import { Router }         from './Router'
import { AuthProvider }   from './providers/AuthProvider'
import { SpeedInsights }  from '@vercel/speed-insights/react'

/**
 * SpeedInsights reports real-user load performance (Core Web Vitals) to
 * Vercel. It renders nothing and is deliberately OUTSIDE AuthProvider -
 * it needs no auth context, and performance should be measured for
 * logged-out visitors too.
 *
 * This is measurement, not analytics: page timings, no visitor counts,
 * no profiles. It IS a third party receiving data, so it must be
 * declared in the app's privacy policy when that is written.
 *
 * Deliberately NOT added to the Landing site - lukaduka.life's privacy
 * notice states that site has no analytics and no trackers, and that
 * must stay true.
 */
export default function App() {
  return (
    <>
      <AuthProvider>
        <Router />
      </AuthProvider>
      <SpeedInsights />
    </>
  )
}